
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import './input-checkbox-field.scss';

const InputCheckboxField = (props) => {
    const { param, handleChange, value } = props;

    return (
        <FormControlLabel
            className="inputCheckboxField"
            control={
                <Checkbox
                    defaultChecked={!!value}
                    onChange={handleChange}
                    name={param.field}
                    size="small"
                />
            }
            label={param.headerName}
        />
    );
};
export default InputCheckboxField;
